<template>
  <div class="column is-12">
    <div class="columns">
      <div class="column is-5 label">
        <p>{{ $t('bookings.from') }}</p>
      </div>
      <div class="column is-5 label">
        <p>{{ $t('bookings.until') }}</p>
      </div>
    </div>

    <div
      :key="lockTime.id"
      v-for="lockTime in lockTimes"
      class="columns"
    >
      <div class="column is-5 text-with-input">
        <form-input
          v-model="lockTime.from"
          class="settings__input"
          :options="{ inputtype: 'date' }"
        />
      </div>
      <div class="column is-5 text-with-input">
        <form-input
          v-model="lockTime.until"
          class="settings__input"
          :options="{ inputtype: 'date' }"
        />
      </div>

      <div class="column is-2 label">
        <button
          class="settings__input--file-upload button is-success"
          :class="{ 'is-loading' : updatingLockTime }"
          @click="saveLockTime(lockTime.id)"
        >
          <i class="fa fa-save" aria-hidden="true"/>
        </button>

        <button
          v-if="!lockTime.isNew"
          class="settings__input--file-upload button is-danger ml-1"
          :class="{ 'is-loading' : updatingLockTime }"
          @click="removeLockTime(lockTime.id)"
        >
          <i class="fa fa-trash" aria-hidden="true"/>
        </button>
      </div>
    </div>

    <div class="columns">
      <template v-if="newLockTime">
        <div class="column is-5 text-with-input">
          <form-input
            v-model="newLockTime.from"
            class="settings__input"
            :options="{ inputtype: 'date' }"
          />
        </div>
        <div class="column is-5 text-with-input">
          <form-input
            v-model="newLockTime.until"
            class="settings__input"
            :options="{ inputtype: 'date' }"
          />
        </div>

        <div class="column is-2 label">
          <button
            class="settings__input--file-upload button is-success"
            :class="{ 'is-loading' : updatingLockTime }"
            @click="saveLockTime(null)"
          >
            <i class="fa fa-save" aria-hidden="true"/>
          </button>
        </div>
      </template>

      <div
        class="column is-8 text-with-input"
        v-else
      >
        <button
          class="button is-primary"
          :class="{ 'is-loading' : updatingLockTime }"
          @click="initNewLockItem"
        >
          {{ $t('settings.lockTimes.add') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    import { FormInput } from '../../index';
    import { Api } from '../../../../api';
    import { AppModel } from '../../../../models';

    export default {
        name: 'LockTimesTab',
        components: { FormInput },
        data() {
            return {
                newLockTime: null,
                updatingLockTime: false,
                lockTimes: [],
            };
        },
        created() {
            this.fetchLockTimes();
        },
        methods: {
            initNewLockItem() {
                this.newLockTime = {
                    from: null,
                    until: null,
                    isNew: true,
                };
            },
            async fetchLockTimes() {
                const res = await Api.lockTimes.getLockTimes();
                this.lockTimes = (res.data || []).map(item => ({
                    id: item.id,
                    from: item.locked_from || item.from || null,
                    until: item.locked_until || item.until || null,
                    didTimeUpdate: false,
                    isNew: false,
                }));
            },
            showLockTimeError(response) {
                if(response.status > 201) {
                    // eslint-disable-next-line no-undef
                    EventBus && EventBus.$emit && EventBus.$emit(EventBus.SHOW_NOTIFICATION,
                        {
                            title: this.$t('generic.formErrorHeadline'),
                            body: response.body,
                            direction: 'Up',
                            type: 'danger',
                            duration: 10000,
                        });
                }
            },
            async addNewLockTime() {
                if(this.newLockTime && this.newLockTime.from && this.newLockTime.until) {
                    this.updatingLockTime = true;
                    const res = await Api.lockTimes.createLockTime({
                        campground_slug: AppModel.activeCampground.slug,
                        'locked_from': this.newLockTime.from,
                        'locked_until': this.newLockTime.until,
                    });
                    this.showLockTimeError(res);
                    await this.fetchLockTimes();
                    this.updatingLockTime = false;
                    this.newLockTime = null;
                }
            },
            async updateLockTime(from, until, lockTimeId) {
                this.updatingLockTime = true;
                const res = await Api.lockTimes.changeLockTime({
                    campground_slug: AppModel.activeCampground.slug,
                    'locked_from': from,
                    'locked_until': until,
                    id: lockTimeId,
                });
                this.showLockTimeError(res);
                await this.fetchLockTimes();
                this.updatingLockTime = false;
            },
            async saveLockTime(id) {
                this.updatingLockTime = true;
                if(id) {
                    const lt = (this.lockTimes || []).find(x => x.id === id);
                    if(lt) {
                        await this.updateLockTime(lt.from, lt.until, lt.id);
                    } else {
                        this.updatingLockTime = false;
                    }
                } else {
                    await this.addNewLockTime();
                }
            },
            async removeLockTime(lockTimeId) {
                this.updatingLockTime = true;
                await Api.lockTimes.deleteLockTime(lockTimeId);
                await this.fetchLockTimes();
                this.updatingLockTime = false;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/LockTimesTab.vue